const constants = {
  cellSize: 31,
  borderSize: 2,
  numberSize: 9,
};

export { constants };
